/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useMemo, useCallback } from 'react'
import { UserContext } from 'stores/UserStore'
import field from 'api/field'
import _ from 'lodash'
import { descompressResponse } from 'utils/decompress'

export const FieldDataContext = React.createContext({})

export const FieldDataProvider = ({ children }) => {

  const { idToken } = useContext(UserContext)
    const [isLoading, setLoading] = useState(false)
    const [tableData, setTableData] = useState([])
    const [filters, setFilters] = useState({})
    const [tagsFilters, setTagsFilters] = useState({})
    const [selectedItem, setSelectedItem] = useState()

    const getFieldData = useCallback(() => new Promise((resolve, reject) => {
        setLoading(true)
        setTableData([])

        field.data(idToken, {init: true}).then(data => {
          data = data.body ? data.body : data
          const descompressData = descompressResponse(data)
          setTableData(descompressData.tableData)
            setLoading(false)
            resolve()
        }).catch(e => {
          reject(e)
        })

    }), [idToken])    
    
    const uploadManualData = useCallback((upload) => new Promise((resolve, reject) => {
      setLoading(true)

      field.data(idToken, upload).then(data => {
        setLoading(false)
        resolve()
      }).catch(e => {
        reject(e)
      })

  }), [idToken])    
    
   const filteredFieldData = useMemo(() => {
      for (const key of Object.keys(filters)) {
        if (filters[key].length === 0) {
          delete filters[key]
        }
      } 
      const filteredTableData = _.filter(tableData, item => {
        let match = true
        _.chain(filters)
          .pickBy(filter => filter.length > 0)
          .each((filter, key) => {
            const itemValue = _.get(item, key)
            match = match && _.includes(filter, itemValue)
          })
          .value()
        return match
      })
      return {
        ...tableData,
        tableData: filteredTableData
      }
    }, [filters, tableData])
    

    const filteredFieldTags = useMemo(() => {
      const tagsTableData = selectedItem ? selectedItem.tags : []
      for (const key of Object.keys(tagsFilters)) {
        if (tagsFilters[key].length === 0) {
          delete tagsFilters[key]
        }
      } 
      const filteredTagsTableData = _.filter(tagsTableData, item => {
        let match = true
        _.chain(tagsFilters)
          .pickBy(filter => filter.length > 0)
          .each((filter, key) => {
            const itemValue = _.get(item, key)
            match = match && _.includes(filter, itemValue)
          })
          .value()
        return match
      })
      return {
        ...tagsTableData,
        tableData: filteredTagsTableData
      }
    }, [tagsFilters, selectedItem])    

    return (
        <FieldDataContext.Provider value={{
            tableData,
            isLoading,
            filteredFieldData,
            filters,
            setFilters,
            selectedItem, 
            setSelectedItem,
            tagsFilters, 
            setTagsFilters,
            filteredFieldTags,
            getFieldData,
            uploadManualData
        }}>
            {children}
        </FieldDataContext.Provider>
    )
}